import { render, staticRenderFns } from "./AlertHasDiscount.vue?vue&type=template&id=1291dca0&scoped=true&"
import script from "./AlertHasDiscount.vue?vue&type=script&lang=ts&"
export * from "./AlertHasDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./AlertHasDiscount.vue?vue&type=style&index=0&id=1291dca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1291dca0",
  null
  
)

export default component.exports